import { type FC, useRef, useState } from 'react';
import styles from './index.module.scss';

import work1 from '@assets/images/vault/work1.svg';
import work2 from '@assets/images/vault/work2.svg';
import work3 from '@assets/images/vault/work3.svg';
import movebit from '@assets/images/vault/movebit.svg';
import EarnTvChart from '@components/earn-tv-chart';
import EarnTvNumber from '@components/earn-tv-number';
import EarnRevenueChart from '@components/earn-revenue-chart';
import EarnRevenueNumber from '@components/earn-revenue-number';
import { Segmented } from 'antd';
import VaultAll from '@components/vault-all';
import MyVault from '@components/my-vault';
import VaultSearch from '@components/vault-search';
import { type CoinStruct } from '@models/coins.vault.model';
import { useVaultSummary } from '@hooks/use-vault-summary';
import { useMyVaults } from '@hooks/use-my-vaults';

const tabsItem = ['All Vaults', 'My Vaults'];

const Earn: FC = () => {
  const { myVaults } = useMyVaults();
  const { summary } = useVaultSummary();

  const [searchValue, setSearchValue] = useState<CoinStruct[]>([]);
  const [tabValue, setTabValue] = useState(tabsItem[0]);
  const divRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    divRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <div className={styles.main}>
        <div className={styles.banner}>
          <div className={styles.banner_text1}>Easier, safer, earn yield.</div>
          <div className={styles.banner_text2} onClick={handleClick}>
            How it works?
          </div>
        </div>
        <div className={styles.move_bit}>
          Audited by
          <img src={movebit} />
        </div>

        <div className={styles.chart_con}>
          <EarnTvChart summary={summary} />
          <div className={styles.chart_right}>
            <EarnTvNumber summary={summary} />
          </div>
        </div>
        <div className={styles.chart_con1}>
          <EarnRevenueChart summary={summary} />
          <div className={styles.chart_right}>
            <EarnRevenueNumber myVaults={myVaults} />
          </div>
        </div>

        <div className={styles.chart_mobile}>
          <EarnTvNumber summary={summary} />
          <EarnRevenueNumber myVaults={myVaults} />
        </div>

        <div className={styles.vault}>
          <Segmented
            value={tabValue}
            options={tabsItem}
            onChange={(value) => {
              setTabValue(value); //
              setSearchValue([]);
            }}
          />
          {tabValue === 'All Vaults' && (
            <VaultSearch searchValue={searchValue} onChangeSearchValue={setSearchValue} />
          )}
        </div>

        {tabValue === 'All Vaults' && <VaultAll searchValue={searchValue} myVaults={myVaults} />}
        {tabValue === 'My Vaults' && <MyVault myVaults={myVaults} />}

        <div className={styles.work_title} ref={divRef}>
          How it works
        </div>
        <div className={styles.work_list}>
          <div>
            <div className={styles.work_img}>
              <div>
                <img src={work1} />
              </div>
            </div>
            <div className={styles.work_text}>One-click deposit, supports single token.</div>
          </div>
          <div>
            <div className={styles.work_img}>
              <div className={styles.blue}>
                <img src={work2} />
              </div>
            </div>
            <div className={styles.work_text}>
              Automatic compounding and automatic position management
            </div>
          </div>
          <div>
            <div className={styles.work_img}>
              <div className={styles.yellow}>
                <img src={work3} />
              </div>
            </div>
            <div className={styles.work_text}>
              Earn yield, earn Parrot points. Instant Withdrawals
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Earn;
